import React__default from 'react';
import classnames from 'classnames';
import { MediaQuery, Carousel, LazyImage } from '@grandvisionhq/common';

const VariantSwitcherItem = ({ image , sku , isActive , onClick  })=>{
    const handleClick = React__default.useCallback((e)=>{
        onClick(sku);
        e.preventDefault();
        e.stopPropagation();
    }, [
        sku
    ]);
    if (!image) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement("button", {
        onClick: handleClick,
        "aria-label": image.alt || '',
        className: classnames('variant-switcher-item', {
            'variant-switcher-item--active': isActive
        })
    }, /*#__PURE__*/ React__default.createElement(LazyImage, {
        className: "variant-switcher-item__image",
        src: image.url,
        alt: image.alt || '',
        // 16:9 ratio
        height: 22.5,
        width: 40
    }));
};
const VariantSwitcher = ({ variants , activeSku , onVariantChange , className ,  })=>{
    const itemsPerSlide = MediaQuery.useIsPhone() ? 2 : 3;
    const carouselItems = React__default.useMemo(()=>{
        const max = Math.ceil(variants.length / itemsPerSlide);
        const items = [];
        for(let i = 0; i < max; i++){
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            items.push(/*#__PURE__*/ React__default.createElement("div", {
                key: `variant-switcher-${i}`,
                className: classnames('variant-switcher__slide', {
                    'variant-switcher__slide--single': max === 1
                })
            }, variants.slice(start, end).map(({ sku , image  })=>/*#__PURE__*/ React__default.createElement(VariantSwitcherItem, {
                    key: sku,
                    image: image,
                    sku: sku,
                    isActive: sku === activeSku,
                    onClick: onVariantChange
                })
            )));
        }
        return items;
    }, [
        variants,
        activeSku,
        onVariantChange,
        itemsPerSlide
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('variant-switcher', className)
    }, /*#__PURE__*/ React__default.createElement(Carousel, {
        pagination: false
    }, carouselItems));
};
var VariantSwitcher$1 = VariantSwitcher;

export { VariantSwitcher, VariantSwitcherItem, VariantSwitcher$1 as default };
//# sourceMappingURL=VariantSwitcher.js.map
